// Module
var code = "<button class=\"btn btn-link\" ng-click=\"widget.leftControlsController.manageGroups()\"> <i class=\"fa fa-cog\"></i> Manage Groups </button> ";
// Exports
module.exports = code;